// Generated by Claude Code
import type { FormattedPrice } from '#core/entities/operations/shared/Price.ts'
import { InfoHint } from '#components/primitives/components/info-hint.tsx'
import { useTranslation } from 'react-i18next'

export interface PriceDisplayProps {
  price: FormattedPrice | null
}

/**
 * Renders a {@link FormattedPrice}, or `-` when there is none. Loads its namespace without
 * Suspense, as `PartQuantityStepper` does, since it is mounted from other domains' screens.
 */
export function PriceDisplay({ price }: PriceDisplayProps) {
  const { t } = useTranslation('parts', { useSuspense: false })
  return (
    <span className="d-inline-flex align-items-center gap-1">
      {price?.display ?? '-'}
      {price?.original && (
        <InfoHint label={t('detail.originalPrice')} description={price.original} />
      )}
    </span>
  )
}
